<script setup lang="ts">
defineProps<{
    icon: string;
    title: string;
}>();
</script>

<template>
    <div class="row flex-grow space-between items-center">
        <div class="row flex-grow items-center">
            <div class="q-mr-sm">
                <q-icon :class="icon" size="20px" />
            </div>
            <div class="header-title-semi-bold">{{ title }}</div>
        </div>
        <div>
            <slot name="right" />
        </div>
    </div>
</template>
